import { serializeStyles } from '@emotion/serialize';

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

export default css;



//////////////////
// WEBPACK FOOTER
// ../node_modules/@emotion/css/dist/css.browser.esm.js
// module id = 346
// module chunks = 0